<template>
    <b-button class="float-right"
        variant="success"
        @click.stop="inserirPleito()">
        <span>
            <i class="fa fa-plus mr-2"></i> Inserir Pleito
        </span>
    </b-button>
</template>

<script>
export default {
    props: {
        pleitosServicos: {
            type: Object,
            default: () => ({}) 
        },
        rotaListagem: {
            type: String,
        },
        rotaInserir: {
            type: String,
        }
    },
    methods: {
        inserirPleito() {
            this.$router.push({
                name: this.rotaInserir,
                params: {
                    pleitosServicos: this.pleitosServicos,
                    rotaListagem: this.rotaListagem
                }
            })
        }
    }
}
</script>